import { createSlice } from "@reduxjs/toolkit";
import initialState from "./initialState";
import { fetchAllDailyWorkouts } from "./thunks";
import { initialApiState } from "../common";

const workoutSlice = createSlice({
  name: "workoutSlice",
  initialState,
  reducers: {
    clearWorkouts: (state, action) => {},
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllDailyWorkouts.pending, (state, _action) => {
      state.workouts.state = "pending";
      state.workouts.error = null;
    });
    builder.addCase(fetchAllDailyWorkouts.fulfilled, (state, action) => {
      state.workouts.state = "success";
      state.workouts.data = action.payload;
      state.workouts.error = null;
    });
    builder.addCase(fetchAllDailyWorkouts.rejected, (state, action) => {
      state.workouts.state = "failed";
      state.workouts.data = null;
      state.workouts.error = action.error;
    });
    builder.addCase("common/cleanup", (state, _action) => {
      state.workouts = initialApiState;
    });
  },
});

// Action creators are generated for each case reducer function
export const { clearWorkouts } = workoutSlice.actions;

export default workoutSlice.reducer;
